// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Button_small,
.Button_medium {
  color: #45852e;
  border: 1px solid #45852e;
  border-radius: 8px;
  font-weight: 600;
  background-color: transparent;
  font-family: Inter;
  width: auto;
  margin: 0 5px;
  cursor: pointer;
}

.Button_small {
  min-width: 100px;
  max-width: 245px;
  min-height: 40px;
  font-size: 14px;
}

.Button_small:hover {
  background-color: #45852e !important;
  color: #fff;
}

.Button_content {
  min-width: 100px;
  max-width: 245px;
  min-height: 40px;
  font-size: 14px;
}

.Button_content:hover {
  background-color: #fff;
  color: #45852e;
}

.Button_medium {
  min-width: 116px;
  max-width: 224px;
  min-height: 44px;
  font-size: 16px;
}

.Button_medium:hover {
  background-color: #45852e !important;
  color: #fff;
}

button[disabled] {
  opacity: 0.5;
  cursor: not-allowed;
}

.Export_button {
  display: flex;
  align-items: center;
  justify-content: space-around;
  padding: 0 1rem;
}

.Export_button_downarrow {
  width: 20px;
  height: 20px;
  padding-top: 2px;
}

.Export_button:hover {
  color: #45852e !important;
  border: 1px solid #45852e !important;
  background-color: transparent !important;
}

.Export_button_saperator {
  width: 2px;
  height: 60%;
  background-color: rgba(69, 133, 46, 0.5215686275);
  border-radius: 4px;
  margin-left: 6px;
}`, "",{"version":3,"sources":["webpack://./src/components/UI%20components/Buttons/Button.scss","webpack://./src/components/UI components/Buttons/Button.scss"],"names":[],"mappings":"AAAA;;EAEI,cAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,6BAAA;EACA,kBAAA;EACA,WAAA;EACA,aAAA;EACA,eAAA;ACCJ;;ADEA;EACI,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,eAAA;ACCJ;;ADEA;EACI,oCAAA;EACA,WAAA;ACCJ;;ADCA;EACI,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,eAAA;ACEJ;;ADCA;EACI,sBAAA;EACA,cAAA;ACEJ;;ADCA;EACI,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,eAAA;ACEJ;;ADCA;EACI,oCAAA;EACA,WAAA;ACEJ;;ADCA;EACI,YAAA;EACA,mBAAA;ACEJ;;ADCA;EACI,aAAA;EACA,mBAAA;EACA,6BAAA;EAEA,eAAA;ACCJ;;ADEA;EACI,WAAA;EACA,YAAA;EACA,gBAAA;ACCJ;;ADCA;EACI,yBAAA;EACA,oCAAA;EACA,wCAAA;ACEJ;;ADCA;EACI,UAAA;EACA,WAAA;EACA,iDAAA;EACA,kBAAA;EACA,gBAAA;ACEJ","sourcesContent":[".Button_small,\n.Button_medium {\n    color: #45852e;\n    border: 1px solid #45852e;\n    border-radius: 8px;\n    font-weight: 600;\n    background-color: transparent;\n    font-family: Inter;\n    width: auto;\n    margin: 0 5px;\n    cursor: pointer;\n}\n\n.Button_small {\n    min-width: 100px;\n    max-width: 245px;\n    min-height: 40px;\n    font-size: 14px;\n}\n\n.Button_small:hover {\n    background-color: #45852e !important;\n    color: #fff;\n}\n.Button_content {\n    min-width: 100px;\n    max-width: 245px;\n    min-height: 40px;\n    font-size: 14px;\n}\n\n.Button_content:hover {\n    background-color: #fff;\n    color: #45852e;\n}\n\n.Button_medium {\n    min-width: 116px;\n    max-width: 224px;\n    min-height: 44px;\n    font-size: 16px;\n}\n\n.Button_medium:hover {\n    background-color: #45852e !important;\n    color: #fff;\n}\n\nbutton[disabled] {\n    opacity: 0.5;\n    cursor: not-allowed;\n}\n\n.Export_button {\n    display: flex;\n    align-items: center;\n    justify-content: space-around;\n    // width: 150px;\n    padding: 0 1rem;\n}\n\n.Export_button_downarrow {\n    width: 20px;\n    height: 20px;\n    padding-top: 2px;\n}\n.Export_button:hover {\n    color: #45852e !important;\n    border: 1px solid #45852e !important;\n    background-color: transparent !important;\n}\n\n.Export_button_saperator {\n    width: 2px;\n    height: 60%;\n    background-color: #45852e85;\n    border-radius: 4px;\n    margin-left: 6px;\n}\n",".Button_small,\n.Button_medium {\n  color: #45852e;\n  border: 1px solid #45852e;\n  border-radius: 8px;\n  font-weight: 600;\n  background-color: transparent;\n  font-family: Inter;\n  width: auto;\n  margin: 0 5px;\n  cursor: pointer;\n}\n\n.Button_small {\n  min-width: 100px;\n  max-width: 245px;\n  min-height: 40px;\n  font-size: 14px;\n}\n\n.Button_small:hover {\n  background-color: #45852e !important;\n  color: #fff;\n}\n\n.Button_content {\n  min-width: 100px;\n  max-width: 245px;\n  min-height: 40px;\n  font-size: 14px;\n}\n\n.Button_content:hover {\n  background-color: #fff;\n  color: #45852e;\n}\n\n.Button_medium {\n  min-width: 116px;\n  max-width: 224px;\n  min-height: 44px;\n  font-size: 16px;\n}\n\n.Button_medium:hover {\n  background-color: #45852e !important;\n  color: #fff;\n}\n\nbutton[disabled] {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.Export_button {\n  display: flex;\n  align-items: center;\n  justify-content: space-around;\n  padding: 0 1rem;\n}\n\n.Export_button_downarrow {\n  width: 20px;\n  height: 20px;\n  padding-top: 2px;\n}\n\n.Export_button:hover {\n  color: #45852e !important;\n  border: 1px solid #45852e !important;\n  background-color: transparent !important;\n}\n\n.Export_button_saperator {\n  width: 2px;\n  height: 60%;\n  background-color: rgba(69, 133, 46, 0.5215686275);\n  border-radius: 4px;\n  margin-left: 6px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
